// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9b1a6254","453":"ea754358"}[chunkId] + ".chunk.js";
};